module.exports = __webpack_public_path__ + "static/vmware_10.ab868773.jpg";